<template>
  <div class="studyduration-chart">
    <el-card class="box-card">
      <template slot="header">
        <div class="clearfix">
          <div>
            <span>{{ chartTitle }}</span>
            <!-- 小节名称展示区域 -->
            <el-tag type="info" size="small" class="period-name-tag" v-if="periodName">
              小节：{{ periodName }}
            </el-tag>
          </div>
          <el-button type="text" icon="el-icon-arrow-left" size="small" @click="handleBack">返回</el-button>
        </div>
      </template>
      <div class="chart-wrapper" v-loading="loading" element-loading-text="正在加载数据..." element-loading-background="rgba(255, 255, 255, 0.8)">
        <div ref="chartContainer" class="chart-container" style="width: 100%; height: 400px;"></div>
      </div>
      
      <el-table :data="this.userList" style="width: 100%; margin-top: 20px;" border v-loading="loadingList">
        <el-table-column prop="user_id" label="用户ID" align="center"></el-table-column>
        <el-table-column prop="username" label="用户名称" align="center"></el-table-column>
        <el-table-column prop="study_duration" label="学习时长（秒）" align="center"></el-table-column>
        <el-table-column prop="study_duration_format" label="学习时长" align="center"></el-table-column>
        <el-table-column prop="percentage" label="学习进度" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.percentage }}%</span>
          </template>
        </el-table-column>
<!--        <el-table-column prop="percentage_range" label="占比区间" align="center">
          <template slot-scope="scope">
            <el-tag :type="getRangeType(scope.row.percentage_range)">{{ scope.row.percentage_range }}</el-tag>
          </template>
        </el-table-column>-->
      </el-table>
      
      <!-- 分页组件 -->
      <div class="pagination-container" v-if="total > pageSize">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size.sync="pageSize"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { getStudyDurationData, getUserStudyDurationList } from "@/api/datastatistics";

export default {
  name: 'StudyDurationChart',
  data() {
    return {
      loading: false,
      loadingList: false,
      chartTitle: '学习进度用户数统计',
      chartInstance: null,
      periodId: '',
      periodName: '', // 小节名称
      startEndTime: [],
      userList: [], // 完整数据列表
      currentPage: 1,
      pageSize: 20,
      total: 0,
      chartData: {
        categories: ['小于10%', '10%-25%', '25%-50%', '50%-80%', '大于80%'],
        series: [0, 0, 0, 0, 0]
      }
    };
  },
  computed: {
    // 计算当前页显示的数据
    paginatedUserList() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.userList.slice(start, end);
    }
  },
  mounted() {
    this.periodId = this.$route.query.period_id;
    this.startEndTime = JSON.parse(this.$route.query.start_end_time || '[]');
    // 设置小节名称
    this.setPeriodName();
    this.initChart();
    // 初始加载时同时加载进度占比和学员列表
    this.loadPercentageData();
    this.loadUserListData();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chartContainer);
      const option = {
        title: {
          text: '学习进度用户数统计（数据以学员最长学习时长为准）',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            return params[0].name + ': ' + params[0].value + ' 人';
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.chartData.categories,
          axisLabel: {
            interval: 0,
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          name: '人数',
          minInterval: 1
        },
        series: [
          {
            data: this.chartData.series,
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: '#83bff6'},
                {offset: 0.5, color: '#188df0'},
                {offset: 1, color: '#188df0'}
              ])
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: '#2378f7'},
                  {offset: 0.7, color: '#2378f7'},
                  {offset: 1, color: '#83bff6'}
                ])
              }
            },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}人'
            }
          }
        ]
      };
      this.chartInstance.setOption(option);
    },
    updateChart() {
      if (!this.chartInstance) return;
      const percentageData = this.chartData.percentage || [];
      this.chartInstance.setOption({
        xAxis: {
          data: this.chartData.categories
        },
        series: [{
          data: this.chartData.series.map((value, index) => {
            // 将 percentage 数据追加到 value 后面
            const percentage = percentageData[index] || '0%';
            return {
              value: value,
              label: {
                show: true,
                position: 'top',
                formatter: `${value}人 (${percentage})`
              }
            };
          })
        }]
      });
    },
    // 加载学习进度占比数据
    loadPercentageData() {
      this.loading = true;
      const params = {
        period_id: this.periodId,
        start_end_time: this.startEndTime,
        // 仅获取统计数据，不获取用户列表
        only_statistics: true
      };
      
      getStudyDurationData(params).then((res) => {
        if(res.code == 1 && res.data) {
          // 只处理图表数据
          if (res.data.chart_data) {
            this.chartData = res.data.chart_data;
            this.periodName = res.data.chart_data.period_title;
          }
          this.updateChart();
        } else {
          console.error('获取学习进度占比数据失败');
          // 使用模拟的进度占比数据
          this.generateMockPercentageData();
          this.updateChart();
        }
        this.loading = false;
      }).catch((error) => {
        console.error('请求学习进度占比数据时发生错误:', error);
        // 发生错误时使用模拟数据
        this.generateMockPercentageData();
        this.updateChart();
        this.loading = false;
      });
    },
    // 加载学员列表数据（带分页）
    loadUserListData() {
      this.loadingList = true;
      const params = {
        period_id: this.periodId,
        start_end_time: this.startEndTime,
        page: this.currentPage,
        limit: this.pageSize
      };

      getUserStudyDurationList(params).then((res) => {
        if(res.code == 1 && res.data) {
          // 处理学员列表数据
          if (res.data.total !== undefined) {
            this.total = res.data.total;
          }
          
          if (res.data.list && Array.isArray(res.data.list)) {
            this.userList = res.data.list.map(user => ({
              ...user,
              study_duration_format: this.formatDuration(user.study_duration)
            }));

            // 如果API没有返回总数，使用数组长度
            if (res.data.total === undefined) {
              this.total = this.userList.length;
            }
          } else {
            this.userList = [];
            this.total = 0;
          }
        } else {
          console.error('获取学员列表数据失败，使用模拟数据');
          // 生成模拟的学员列表数据
          this.generateMockUserList();
        }
        this.loadingList = false;
      }).catch((error) => {
        console.error('请求学员列表数据时发生错误:', error);
        // 发生错误时使用模拟数据
        this.generateMockUserList();
        this.loadingList = false;
      });
    },
    // 根据用户列表生成图表数据
    generateChartDataFromUserList(userList) {
      this.chartData = {
        categories: ['小于10%', '10%-25%', '25%-50%', '50%-80%', '大于80%'],
        series: [0, 0, 0, 0, 0]
      };
      
      userList.forEach(user => {
        let rangeIndex = 0;
        if (user.percentage < 10) {
          rangeIndex = 0;
        } else if (user.percentage >= 10 && user.percentage < 25) {
          rangeIndex = 1;
        } else if (user.percentage >= 25 && user.percentage < 50) {
          rangeIndex = 2;
        } else if (user.percentage >= 50 && user.percentage < 80) {
          rangeIndex = 3;
        } else {
          rangeIndex = 4;
        }
        this.chartData.series[rangeIndex]++;
      });
    },
    // 生成模拟的进度占比数据
    generateMockPercentageData() {
      // 模拟进度占比数据
      this.chartData = {
        categories: ['小于10%', '10%-25%', '25%-50%', '50%-80%', '大于80%'],
        series: [
          Math.floor(Math.random() * 20) + 5,
          Math.floor(Math.random() * 25) + 10,
          Math.floor(Math.random() * 30) + 15,
          Math.floor(Math.random() * 20) + 10,
          Math.floor(Math.random() * 15) + 5
        ]
      };
    },
    // 生成模拟的学员列表数据
    generateMockUserList() {
      const totalDuration = 3600; // 假设总时长为1小时
      const userCount = this.pageSize; // 当前页的数据量
      
      this.userList = [];
      // 假设总数为100
      this.total = 100;
      
      // 计算起始索引
      const startIndex = (this.currentPage - 1) * this.pageSize;
      
      for (let i = 0; i < userCount; i++) {
        const actualIndex = startIndex + i;
        const studyDuration = Math.floor(Math.random() * (totalDuration + 1));
        const percentage = Math.round((studyDuration / totalDuration) * 100);
        
        // 确定占比区间
        let percentageRange = '小于10%';
        
        if (percentage < 10) {
          percentageRange = '小于10%';
        } else if (percentage >= 10 && percentage < 25) {
          percentageRange = '10%-25%';
        } else if (percentage >= 25 && percentage < 50) {
          percentageRange = '25%-50%';
        } else if (percentage >= 50 && percentage < 80) {
          percentageRange = '50%-80%';
        } else {
          percentageRange = '大于80%';
        }
        
        this.userList.push({
          username: `用户${actualIndex + 1}`,
          user_id: `UID${1000 + actualIndex}`,
          study_duration: studyDuration,
          study_duration_format: this.formatDuration(studyDuration),
          percentage: percentage,
          percentage_range: percentageRange
        });
      }
      
      // 按学习时长降序排序
      this.userList.sort((a, b) => b.study_duration - a.study_duration);
    },
    formatDuration(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      
      let result = '';
      if (hours > 0) result += `${hours}小时`;
      if (minutes > 0) result += `${minutes}分钟`;
      if (secs > 0) result += `${secs}秒`;
      
      return result || '0秒';
    },
    getRangeType(range) {
      // 根据占比区间返回不同的标签类型
      switch(range) {
        case '小于10%': return 'danger';
        case '10%-25%': return 'warning';
        case '25%-50%': return 'info';
        case '50%-80%': return 'primary';
        case '大于80%': return 'success';
        default: return 'default';
      }
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    handleBack() {
      this.$router.back();
    },
    // 分页相关方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      // 只加载学员列表数据，不重新加载进度占比
      this.loadUserListData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // 只加载学员列表数据，不重新加载进度占比
      this.loadUserListData();
    },
    
    // 设置小节名称
    setPeriodName() {
      // 这里可以替换为实际的API调用，根据periodId获取小节名称
      // 暂时使用periodId作为展示，实际应用中应替换为真实的小节名称
      this.periodName = this.periodId || '未知小节';
      // 示例：从API获取小节名称
      /*
      getPeriodName(this.periodId).then(res => {
        if(res.code === 1 && res.data) {
          this.periodName = res.data.name || this.periodId;
        }
      }).catch(error => {
        console.error('获取小节名称失败:', error);
        this.periodName = this.periodId || '未知小节';
      });
      */
    }
  }
};
</script>

<style scoped>
.studyduration-chart {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.chart-wrapper {
  margin-top: 20px;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-button {
  margin-left: auto;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.period-name-tag {
  margin-left: 10px;
  vertical-align: middle;
}
</style>